export default __webpack_public_path__ + "static/media/crimsonsuccor.d842a356.png";